export enum ConfirmationMode {
    AvailableBalance = 'available-balance',
    AutoConfirmPaymentMethod = 'auto-confirm-payment-method',
}
